export default {"src":"/_next/static/media/VOGUE_LOGO.9cb6bfc6.svg","height":410,"width":1544,"blurWidth":0,"blurHeight":0};